import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./CreateGroupModal.css";

const DraftDocumentModal = ({
  show,
  handleClose,
  handleDraft,
  handleClear,
  attachments,
  isInfoModal,
  message,
}) => {
  // Disable Download button if there are no attachments
  const isDownloadDisabled = attachments.length === 0;

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>
          {isInfoModal ? "Info" : "Draft Documents"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isInfoModal ? (
          <p>{message ? message : "This instance has no attachment."}</p>
        ) : (
          <>
            <p>The selected documents will be drafted in the below order:</p>
            <ul>
              {attachments.map((att, index) => (
                <li
                  key={index}
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    maxWidth: "90%",
                  }}
                >
                  {att.attachment}
                </li>
              ))}
            </ul>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {isInfoModal ? (
          <Button
            variant="primary"
            onClick={handleClose}
            className="create-button"
          >
            OK
          </Button>
        ) : (
          <>
            <Button
              variant="primary"
              onClick={handleDraft}
              className="create-button"
              disabled={isDownloadDisabled} // Disable button if no attachments
            >
              Download
            </Button>
            <Button
              variant="secondary"
              onClick={handleClose}
              className="cancell-button cancell-button-container"
            >
              Save & Continue
            </Button>
            <Button
              variant="danger"
              onClick={handleClear}
              // className="clear-button"
            >
              Clear Above Selection
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DraftDocumentModal;
